import { ToolbarButton } from '../ToolbarButton'
import { ArrangeToBack, ArrangeToFront, Check2, CopyRight2, Lock3, MoreDots, Trash2 } from 'blaze-ui/icons'
import { useActions } from 'components/VisualStudioPlayground/VisualEditor/hooks/useActions'
import { Item, Section } from '@react-stately/collections'
import { Menu } from 'components/Menu/Menu'
import { ActionId } from 'components/VisualStudioPlayground/VisualEditor/Types'
import { TLShape } from '@tldraw/tldraw'
import { ImageShape } from 'components/VisualStudioPlayground/Shapes/ImageShape/Types'
import { MaskShape } from 'components/VisualStudioPlayground/Shapes/MaskShape/Types'
import { GeoShape } from 'components/VisualStudioPlayground/Shapes/GeoShape/Types'
import { TextBoxShape } from 'components/VisualStudioPlayground/Shapes/TextBoxShape/Types'
import { FrameShape } from 'components/VisualStudioPlayground/Shapes/FrameShape/Types'
import { VideoShape } from 'components/VisualStudioPlayground/Shapes/VideoShape/Types'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import type { ItemElement } from '@react-types/shared'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { AttributionSummary } from './AttributionSummary'

interface Props {
  selectedShape: TLShape | undefined
}

const MoreOptionsButton = ({ selectedShape }: Props) => {
  const actions = useActions()
  const editor = useEditor()
  const isInGroup = editor.getShapeParent(selectedShape)?.type === 'group'
  const isVideo = selectedShape?.type === 'video'
  const isImage = selectedShape?.type === 'image'
  const imageAssetId = isImage && (selectedShape as ImageShape).props.assetId
  const imageAsset = imageAssetId ? editor.getAsset(imageAssetId) : undefined
  const imageMediaFileId = imageAsset?.meta.mediaFileId as string | undefined

  return (
    <DropdownTrigger __UNSAFE_popoverStyle={{ width: 250 }}>
      <ToolbarButton frontIcon={MoreDots} aria-label="More options" />
      {(close) => (
        <>
          {imageMediaFileId && <AttributionSummary mediaFileId={imageMediaFileId} />}
          <Menu
            aria-label="Options menu"
            onAction={(key) => {
              actions[key as ActionId].onSelect()
              close()
            }}
            disabledKeys={isInGroup ? ['toggle-lock'] : []}
          >
            <Section>
              <Item key="bring-to-front" textValue="Bring to Front">
                <ArrangeToFront />
                Bring to Front
              </Item>
              <Item key="send-to-back" textValue="Send to Back">
                <ArrangeToBack />
                Send to Back
              </Item>
            </Section>
            <Section>
              {
                [
                  !isVideo && (
                    <Item key="duplicate" textValue="Duplicate">
                      <CopyRight2 />
                      Duplicate
                    </Item>
                  ),
                  <Item key="toggle-lock" textValue="Lock Object">
                    <Lock3 />
                    Lock Object
                    {!(selectedShape as ImageShape | MaskShape | GeoShape | TextBoxShape | FrameShape | VideoShape)
                      ?.props.isEditable && <Check2 size={16} color="var(--selected-stroke)" />}
                  </Item>,
                  <Item key="delete" textValue="Delete">
                    <Trash2 />
                    Delete
                  </Item>,
                ].filter(Boolean) as ItemElement<HTMLElement>[]
              }
            </Section>
          </Menu>
        </>
      )}
    </DropdownTrigger>
  )
}

export { MoreOptionsButton }
